import { clsx } from 'clsx'
import styles from './Ada.module.scss'

const AdaBannerWallpaper = () => (
  <div className={clsx(styles.wrapper, styles['superbanner-wallpaper'])}>
    <div className={'gujAd'} id="superbanner_1"></div>
    <div className={'gujAd'} id="wallpaper_1"></div>
  </div>
)

export default AdaBannerWallpaper
